import { Tag } from "antd"

const StatusTag = ({ status, style = false, className = false, color: colorOverride }) => {
  const statusColorGroups = {
    success: ["online", "finished", "completed", "success", "compliant", "enrolled", "accepted", "connected", "working", "installed"],
    warning: ["away", "onbreak", "connecting", "disconnecting", "idle", "break", "on break"],
    orange: ["pending", "invited", "expired", "skipped", "call", "on call", "media", "watching media", "youtube / media", "requested"],
    error: ["failed", "error", "non-compliant", "cancelled", "rejected"],
    default: ["offline", "uninstalled"],
    purple: ["leave", "onleave", "meeting", "in meeting"],
    processing: ["in-progress", "running", "rdp", "vdi", "shell", "remote", "browsing", "office", "app", "in an app", "installing", "approved"],
  }

  let color = colorOverride || "default"
  const lowerStatus =
    typeof status === "string" ? status.toLowerCase() : ""

  if (!colorOverride) {
    for (const [colorCode, statuses] of Object.entries(statusColorGroups)) {
      if (statuses.includes(lowerStatus)) {
        color = colorCode
        break
      }
    }
  }

  return (
    <Tag style={style || undefined} className={className ? `status-tag ${className}` : "status-tag"} color={color}>
      {status}
    </Tag>
  )
}

export default StatusTag
